import React from 'react';
import { Trans } from 'react-i18next';
import ButtonAdd from 'components/ButtonAdd';
import { ROUTE } from 'constants/route';
import { RIGHTS } from 'constants/rights';

const Actions = () => (
  <ButtonAdd
    size="small"
    to={ROUTE.EMAIL_TEMPLATE_DETAIL.replace(':recordId', 'new')}
    right={RIGHTS.EMAIL_TEMPLATE.ADD}
  >
    <Trans>EMAIL_TEMPLATE.NEW</Trans>
  </ButtonAdd>
);

export default Actions;
